import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app'
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from "./locales/en.json"
import heTranslation from "./locales/he.json"
import ToastProvider from './contexts/ToastContext';
import { AuthProvider } from './features/auth';
import config from './constants/aws-config';
import ScreenProvider from './contexts/ScreenContext';
import { AppSyncProvider } from './features/appsync';
import { Amplify } from "aws-amplify"

Amplify.configure(config)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation, dir: "ltr" },
      he: { translation: heTranslation, dir: 'rtl' },
    },
    lng: 'he', // Default language
    fallbackLng: 'he',
    interpolation: { escapeValue: false },
  });

root.render(
  <React.StrictMode>
    <AuthProvider config={{
      UserPoolId: config.Auth?.Cognito.userPoolId!,
      ClientId: config.Auth?.Cognito.userPoolClientId!,
    }}>

      <AppSyncProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AppSyncProvider>
    </AuthProvider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
